jQuery( () => {
    // eslint-disable-next-line no-undef
    new Swiper( '.testimonials-slider', {
        a11y: {
            prevSlideMessage: 'Previous testimonial',
            nextSlideMessage: 'Next testimonial',
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        breakpoints: {
            992: {
                slidesPerView: 2,
                slidesPerGroup: 1,
            },
        },
        centerInsufficientSlides: true,
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 32,
        navigation: {
            prevEl: '.testimonials-slider-prev',
            nextEl: '.testimonials-slider-next',
        },
        watchSlidesProgress: true,
    } );
} );
